import styled from 'styled-components';
import PropTypes from 'prop-types';

const CardBody = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'textSize',
})`
  padding: ${({ theme }) => theme?.spacing?.medium || '1.25rem'};
  flex-grow: 1;
  font-size: ${({ textSize, theme }) =>
    textSize !== 'default' ? theme?.fontSizes[textSize] || '1rem' : 'inherit'};

  @media (max-width: ${({ theme }) => theme?.breakpoints?.mobile || '768px'}) {
    padding: ${({ theme }) => theme?.spacing?.small || '0.625rem'};
    font-size: ${({ textSize, theme }) =>
      textSize !== 'default' ?
        theme?.fontSizes[textSize === 'extraSmall' ? 'extraSmallMobile' : textSize] || '0.65rem' :
        'inherit'};
  }
`;

CardBody.propTypes = {
  textSize: PropTypes.oneOf(['extraSmall', 'small', 'medium', 'large', 'default']),
};

CardBody.defaultProps = {
  textSize: 'default',
};

export default CardBody;
